export default __webpack_public_path__ + "static/media/Bacalisties-2OnXo.1c33fe52.ttf";